import Vue from 'vue';
import axios from '@/apis/axios';

class Nationality 
{
    static async all()
    {
        return Vue.prototype.$cache.rememberForever(`nationality_${process.env.VUE_APP_CACHE_VERSION}`, async () => {
            const response = await axios.get('/api/nationalities');

            return response.data.data;
        });
    }

    static async getSingaporeNationality()
    {
        const response = await axios.get('/api/admin/setup/singapore-nationality');
        return response.data;
    }
}

export default Nationality;